const reviews = [
  {
    id: 1,
    name: "Sue G. Arakas",
    job: "Engineer",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio modi soluta cupiditate tenetur enim sint cumque blanditiis. In laborum natus dignissimos accusamus nam suscipit dolorem magnam, ex recusandae blanditiis corporis!",
  },
  {
    id: 2,
    name: "John Freeman",
    job: "Former Vice President",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio modi soluta cupiditate tenetur enim sint cumque blanditiis. In laborum natus dignissimos accusamus nam suscipit dolorem magnam, ex recusandae blanditiis corporis!",
  },
  {
    id: 3,
    name: "Paul Pruitt",
    job: "Director",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio modi soluta cupiditate tenetur enim sint cumque blanditiis. In laborum natus dignissimos accusamus nam suscipit dolorem magnam, ex recusandae blanditiis corporis!",
  },
  {
    id: 4,
    name: "Tony Niemeyer",
    job: "Project Manager",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio modi soluta cupiditate tenetur enim sint cumque blanditiis. In laborum natus dignissimos accusamus nam suscipit dolorem magnam, ex recusandae blanditiis corporis!",
  },
];

export default reviews;
